import script from "./RegisterView.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterView.vue?vue&type=script&setup=true&lang=ts"

import "./RegisterView.vue?vue&type=style&index=0&id=079ecfcf&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-079ecfcf"]])

export default __exports__